export default "__VITE_PUBLIC_ASSET__364d683d__"